import { LinkHTMLAttributes } from 'react';
import useFeatureToggle from './useFeatureToggle';
import theme from 'Client/components/GlobalStyles/theme';
import appleTouchIcon from 'Client/assets/favicons/apple-touch-icon.png';
import favIcon16 from 'Client/assets/favicons/favicon-16x16.png';
import favIcon32 from 'Client/assets/favicons/favicon-32x32.png';
import favIconSafari from 'Client/assets/favicons/safari-pinned-tab.svg';
import owwAppleTouchIcon from 'Client/assets/favicons/oww-apple-touch-icon.png';
import owwFavIcon16 from 'Client/assets/favicons/oww-favicon-16x16.png';
import owwFavIcon32 from 'Client/assets/favicons/oww-favicon-32x32.png';
import owwFavIconSafari from 'Client/assets/favicons/oww-safari-pinned-tab.svg';

const useFavicons: () => Record<
    'appleTouchIcon' | 'favIcon16' | 'favIcon32' | 'favIconSafari',
    LinkHTMLAttributes<Element>
> = () => {
    const { p100OneWestwingHeader } = useFeatureToggle();
    const icons = p100OneWestwingHeader
        ? {
              appleTouchIcon: owwAppleTouchIcon,
              favIcon16: owwFavIcon16,
              favIcon32: owwFavIcon32,
              favIconSafari: owwFavIconSafari,
          }
        : { appleTouchIcon, favIcon16, favIcon32, favIconSafari };

    return {
        appleTouchIcon: {
            href: icons.appleTouchIcon,
            rel: 'apple-touch-icon',
            sizes: '180x180',
        },
        favIcon16: {
            href: icons.favIcon16,
            rel: 'icon',
            type: 'image/png',
            sizes: '16x16',
        },
        favIcon32: {
            href: icons.favIcon32,
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
        },
        favIconSafari: {
            href: icons.favIconSafari,
            rel: 'mask-icon',
            color: p100OneWestwingHeader ? '#62bba5' : theme.colors.turquoise100,
        },
    };
};

export default useFavicons;
